import {ContentfulProse} from '@github-ui/swp-core/components/contentful/ContentfulProse'
import {Grid, Box, Stack} from '@primer/react-brand'
import {Lede} from '../../../components/Lede/Lede'
import styles from './WhitepaperPage.module.css'
import type {WhitepaperPage} from '../../../lib/types/contentful/contentTypes/templateWhitepaper'
import {WhitepaperHeader} from './WhitepaperHeader'

type WhitepaperProps = {
  component: WhitepaperPage
}

export function WhitepaperComponent({component}: WhitepaperProps) {
  const {lede, body} = component.fields

  return (
    <Grid className={styles.whitepaperGrid}>
      <Grid.Column span={12}>
        <WhitepaperHeader component={component} />
      </Grid.Column>
      <Grid.Column span={12}>
        <Grid>
          <Grid.Column span={{xsmall: 12, medium: 8}}>
            <Stack>
              <Box marginBlockEnd={{narrow: 24, wide: 48}}>
                <header>
                  <Lede content={lede} />
                </header>
              </Box>
              <ContentfulProse variant="editorial" component={body} />
            </Stack>
          </Grid.Column>
          <Grid.Column span={{xsmall: 12, medium: 4}}>
            {/* TODO: Put in ContentfulForm Component when available */}
            <div id="form" />
          </Grid.Column>
        </Grid>
      </Grid.Column>
    </Grid>
  )
}

try{ WhitepaperComponent.displayName ||= 'WhitepaperComponent' } catch {}